export function onError(error) {
  let errorInfo = {};
  if (error) {
    let message = error.toString();
  
    // Auth errors
    if (!(error instanceof Error) && error.message) {
      errorInfo = error;
      message = error.message;
      error = new Error(message);
      // API errors
    } else if (error.config && error.config.url) {
      errorInfo.url = error.config.url;
    }

    alert(message);
  } else {
    alert("Error");
  }
}
